import { behaviorKey, behaviorsKey } from '../variables.ts'
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage
} from './localStorage'

export const behavior = {
  get: function () {
    let behavior = getLocalStorage(behaviorsKey) || {}

    // if there are older history records
    // compatible for attribution for a while(remove this after 2022/10/31)
    const history = getLocalStorage(behaviorKey)
    if (history) {
      behavior = history.sequence.reduce((a, b) => {
        const savedTargetAction = a[b.target]
        if (savedTargetAction && savedTargetAction.provider === 'rosetta') {
          // 如果有 rosetta honor 的舊資料
          // 只要新的動作不是 rosetta honor，就忽略
          if (
            b.provider === 'rosetta' &&
            !(savedTargetAction.action === 'select' && b.action === 'click')
          ) {
            // 舊的跟新的皆為 rosetta honor，且舊的資料權重較高時，忽略
            // 其他情況只要新的動作是 rosetta honor，就存入
            return { ...a, [b.target]: b }
          }
        } else if (savedTargetAction) {
          // 如果有非 rosetta honor 的舊資料
          // 舊的資料權重較高時，忽略
          if (
            b.provider === 'rosetta' ||
            (b.provider &&
              !(savedTargetAction.action === 'select' && b.action === 'click'))
          )
            return { ...a, [b.target]: b }
        } else {
          // 如果沒有舊資料
          return { ...a, [b.target]: b.provider ? b : null }
        }

        return a
      }, {})

      removeLocalStorage(behaviorKey)
      setLocalStorage(behaviorsKey, behavior)
    }

    return behavior
  },
  getAttributed: function () {
    const behavior = this.get()
    return Object.keys(behavior).reduce((attributedBehavior, productId) => {
      const savedTargetAction = behavior[productId]
      if (savedTargetAction) {
        return { ...attributedBehavior, [productId]: savedTargetAction }
      }
      return attributedBehavior
    }, {})
  },
  getHonor: function () {
    const behavior = this.get()
    return Object.keys(behavior).reduce((honorBehavior, productId) => {
      const savedTargetAction = behavior[productId]
      if (savedTargetAction && savedTargetAction.provider === 'rosetta') {
        return { ...honorBehavior, [productId]: savedTargetAction }
      }
      return honorBehavior
    }, {})
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  save: function ({ actor, ...payload }) {
    const { target: productId, action, provider } = payload
    const behavior = this.get()

    // 會觸發儲存行為的 events 只有 click & select
    if (['click', 'select'].includes(action)) {
      const savedTargetAction = behavior[productId]
      if (savedTargetAction && savedTargetAction.provider === 'rosetta') {
        // 如果有 rosetta honor 的舊資料
        // 只要新的動作不是 rosetta honor，就忽略
        if (
          provider === 'rosetta' &&
          !(savedTargetAction.action === 'select' && action === 'click')
        ) {
          // 舊的跟新的皆為 rosetta honor，且舊的資料權重較高時，忽略
          // select 的權重比較大，優先看 select 的歸因
          // 如果前一次是 select，後來觸發 click，就不理會
          // 其他情況只要新的動作是 rosetta honor，就存入
          setLocalStorage(behaviorsKey, {
            ...behavior,
            [productId]: payload
          })
        }
      } else if (savedTargetAction) {
        // 如果有非 rosetta honor 的舊資料
        // 舊的資料權重較高時，忽略
        if (
          provider === 'rosetta' ||
          (provider &&
            !(savedTargetAction.action === 'select' && action === 'click'))
        )
          setLocalStorage(behaviorsKey, {
            ...behavior,
            [productId]: payload
          })
      } else {
        // 如果沒有舊資料
        // 如果沒有 provider 的行為就存 null
        // 存 product ID 解決有些平台在某些事件觸發時可能丟失部分 ID 資訊
        setLocalStorage(behaviorsKey, {
          ...behavior,
          [productId]: provider ? payload : null
        })
      }
    }
  },
  clean: function () {
    removeLocalStorage(behaviorsKey)
  }
}
